import { render, staticRenderFns } from "./CreateContent.vue?vue&type=template&id=384fb966&scoped=true"
import script from "./CreateContent.vue?vue&type=script&lang=js"
export * from "./CreateContent.vue?vue&type=script&lang=js"
import style0 from "./CreateContent.vue?vue&type=style&index=0&id=384fb966&prod&lang=scss&scoped=true"
import style1 from "./CreateContent.vue?vue&type=style&index=1&id=384fb966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fb966",
  null
  
)

export default component.exports